import { render, staticRenderFns } from "./ViewDoctor.vue?vue&type=template&id=614ba615&scoped=true"
import script from "./ViewDoctor.vue?vue&type=script&lang=js"
export * from "./ViewDoctor.vue?vue&type=script&lang=js"
import style0 from "./ViewDoctor.vue?vue&type=style&index=0&id=614ba615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614ba615",
  null
  
)

export default component.exports